<template>
  <div class="page-content help">
    <h1 class="page-title">{{ $locale('sideMenu.help') }}</h1>
    <coming-soon></coming-soon>
  </div>
</template>

<script>
export default {
  name: "Help",
};
</script>
